(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('waller-product-description')){
 customElements.define('waller-product-description',class extends HTMLElement{
  connectedCallback(){requestAnimationFrame(()=>this.initialize());}
  initialize(){
   if(this.initialized)return;
   const full=this.querySelector('.waller-description__full');
   const preview=this.querySelector('.waller-description__preview');
   const button=this.querySelector('.waller-description__toggle');
   if(!full||!preview||!button)return;
   this.initialized=true;
   if(this.dataset.previewEnabled!=='true'||full.textContent.trim().length<=450)return;
   const paragraphs=[...full.querySelectorAll('p')].filter(p=>p.textContent.trim());
   const intro=paragraphs.find(p=>p.textContent.trim().length>=60)||paragraphs[0];
   if(!intro)return;
   const heading=[...full.querySelectorAll('h1,h2,h3')].find(h=>Boolean(h.compareDocumentPosition(intro)&Node.DOCUMENT_POSITION_FOLLOWING));
   const previewText=(heading?heading.textContent:'')+intro.textContent;
   const remaining=full.textContent.trim().length-previewText.trim().length;
   if(remaining<40&&!full.querySelector('table,ul,ol,iframe,video'))return;
   if(heading)preview.append(heading.cloneNode(true));
   preview.append(intro.cloneNode(true));
   full.hidden=true;preview.hidden=false;button.hidden=false;
   button.addEventListener('click',()=>{
    const expanded=button.getAttribute('aria-expanded')==='true';
    full.hidden=expanded;preview.hidden=!expanded;
    button.setAttribute('aria-expanded',String(!expanded));
    button.querySelector('[data-description-label]').textContent=expanded?'Show full description & specifications':'Show less';
    button.querySelector('[data-description-symbol]').textContent=expanded?'+':'−';
    if(expanded&&this.getBoundingClientRect().top<0)this.scrollIntoView({block:'start',behavior:'smooth'});
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
